export const Finance = () => {
    return (
        <>Финансы</>
    )
}